import React from 'react';
export function FocusSection() {
  return <section className="w-full bg-white py-24 md:py-40 px-6" data-id="element-96">
      <div className="max-w-3xl mx-auto text-center" data-id="element-97">
        <div className="font-serif italic text-2xl md:text-4xl text-charcoal-500 leading-loose space-y-8" data-id="element-98">
          <p data-id="element-99">La maternidad no es solo aprender qué hacer.</p>
          <p data-id="element-100">También es aprender a escuchar… a observar… a conectar</p>
          <p data-id="element-101">Con tu bebé y con vos misma.</p>
          <p className="text-warm-500 mt-12" data-id="element-102">
            Tu bebé no viene con un manual.
            <br data-id="element-103" />
            Pero eso no significa que tengas que hacerlo sola.
          </p>
        </div>
      </div>
    </section>;
}